import * as React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import { isNativeApp } from "../lib/appPlatform";

const STORAGE_KEY = "cookieConsent";

/**
 * Basic cookie banner: informs users about essential cookies/local storage.
 * No analytics/marketing cookies are set; acknowledge to dismiss.
 */
export function CookieBanner() {
  const [visible, setVisible] = React.useState(false);
  const { t } = useLocale();

  React.useEffect(() => {
    // Cookie consent banners are a web/browser concept. The native app uses
    // only essential storage and no analytics, so don't show it there.
    if (isNativeApp()) return;
    const val = localStorage.getItem(STORAGE_KEY);
    if (!val) setVisible(true);
  }, []);

  const accept = React.useCallback(() => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[1200] px-4 pb-4">
      <div className="mx-auto max-w-4xl rounded-2xl border border-gray-200 dark:border-gray-800 bg-white/90 dark:bg-gray-950/90 backdrop-blur shadow-lg p-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="text-sm leading-relaxed text-gray-800 dark:text-gray-100">
          {t(
            "We use essential cookies/local storage for login, sessions, and preferences. We do not run analytics or marketing cookies.",
            "We use essential cookies/local storage for login, sessions, and preferences. We don't run analytics or marketing cookies."
          )}{" "}
          {t("Read more in our", "Read more in our")}{" "}
          <Link className="underline" to="/privacy">
            {t("Privacy Policy")}
          </Link>
          .
        </div>
        <div className="flex items-center gap-2">
          <button
            className="btn px-3 py-2 text-sm bg-slate-900 text-white rounded-lg hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200"
            onClick={accept}
          >
            {t("Got it")}
          </button>
        </div>
      </div>
    </div>
  );
}
